export const NAME = 'pushNotifications';
